// import _ from 'lodash'
import API from '../utilities/API'

class Service {
  static create ({ payload }) {
    return new Promise((resolve, reject) => {
      API
        .refresh()
        .post({url: 'createServicePaymentOption', data: payload})
        .then(response => {
          if (response.SUCCESS) {
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch(response => {
          reject(response)
        })
    })
  }

  static update ({ payload }) {
    return new Promise((resolve, reject) => {
      API
        .refresh()
        .post({url: 'createServicePaymentOption', data: payload})
        .then(response => {
          if (response.SUCCESS) {
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch(response => {
          reject(response)
        })
    })
  }

  static updateService ({ service }) {
    return new Promise((resolve, reject) => {
      API
        .refresh()
        .post({url: 'updateService', data: service})
        .then(response => {
          if (response.SUCCESS) {
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch(response => {
          reject(response)
        })
    })
  }
}

export default Service



// WEBPACK FOOTER //
// ./src/api/services/service.js